import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import PhonesPhoto from '../../assets/images/PinsLandingSvg.png'; // Update with your actual path

const Block6 = () => {
    return (
        <Box
            sx={{
                // p: 4
                p: { xs: 4, sm: 15 },
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }} // Responsive: column for mobile, row for desktop
                alignItems="center"
                spacing={4}
                sx={{
                    justifyContent: 'space-between',
                    flexWrap: 'wrap', // Ensure proper wrapping for smaller screens
                }}
            >
                {/* Text Content */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: { xs: 'left', sm: 'left' }, // Center for mobile, left for desktop
                        maxWidth: { sm: '50%' },
                    }}
                >
                    {/* Phase 1 */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 500,
                            color: '#dc5454',
                            fontSize: { xs: '1.2rem', sm: '2rem' },
                            mb: 2,
                        }}
                    >
                        About Us
                    </Typography>
                    <Typography
                        sx={{
                            textAlign: "justify",
                            fontSize: { xs: '1rem', sm: '1.15rem' },
                            maxWidth: { xs: '100%', sm: '75%' },
                            mb: 4,
                        }}
                    >
                        Our team is made up of expert developers and AI/ML specialists,
                        creative designers, and developers.
                        Together, we bring a diverse range of skills and expertise to drive
                        innovation and deliver exceptional results.
                    </Typography>
                </Box>

                {/* PNG Image */}
                <Box
                    component="img"
                    src={PhonesPhoto}
                    alt="Illustration"
                    draggable="false"
                    sx={{
                        flex: 1,
                        width: { xs: '85%', sm: '50%' }, // 85% width on mobile, 50% width on desktop
                        maxWidth: '480px',
                    }}
                />
            </Stack>
        </Box>
    );
};

export default Block6;
